export enum SupportedDemandType {
  /**
   * No Targeted Vehicle
   */
  TENDER = 'TENDER',
  /**
   * Targeted Vehicle has neither pricing information nor calendar information
   */
  VEHICLE_TARGETED = 'VEHICLE_TARGETED',
  /**
   * Targeted Vehicle has pricing information but lacks of calendar information
   */
  AVAILABILITY = 'AVAILABILITY',
  /**
   * Targeted Vehicle has calendar information but lacks of pricing information
   */
  PRICE = 'PRICE',
  /**
   * Targeted Vehicle has both of calendar and pricing information but disabled immediate reservation feature
   */
  RESERVATION = 'RESERVATION',
  /**
   * Target vehicle has both of calendar and pricing information and enabled immediate reservation feature
   */
  IMMEDIATE_RESERVATION = 'IMMEDIATE_RESERVATION',
}
